import { render, staticRenderFns } from "./setdk.vue?vue&type=template&id=d7da1e80&scoped=true&"
import script from "./setdk.vue?vue&type=script&lang=js&"
export * from "./setdk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7da1e80",
  null
  
)

export default component.exports